import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
const StyledDefinition = styled.dd `
    font-size: ${props => (props.isTotal ? '20px' : '16px')};
    font-weight: ${props => (props.isTotal ? '700' : '400')};
    color: ${props => props.theme.primary.base};
    margin-bottom: 15px;
`;
const DataDefinition = ({ color, children, isTotal, }) => (_jsx(StyledDefinition, { color: color, isTotal: isTotal, children: children }));
export default DataDefinition;
